import { EventEmitter, Injectable } from '@angular/core';
import { EPfmServiceCode, ETransfersServiceCode } from '@common/models';
import { CommonService } from 'src/app/common.service';
import { IContextualMenu } from 'src/app/common/models/contextual-menu.model';
import { HttpRequest, HttpProviderService } from '@fpx/core';
import { environment } from 'src/environments/environment';
import { AccountsService } from 'src/app/services/accounts/accounts.service';
import moment from 'moment';
import { API_DATE_FORMAT } from '@common/constants';
import { Pfmspends } from '../pfmspends-service/pfmspends.model';
import { pfmCategoryHistoryDisplayGrid } from '../pfmtransaction-service/pfmtransaction.model';
import { Pfmbudget } from '../pfmbudget-service/pfmbudget.model';
import { Pfmspendcat } from '../pfmspendcat-service/pfmspendcat.model';
import { Spendcategory } from '../spendcategory-service/spendcategory.model';
import { Pfmfunds } from '../pfmfunds-service/pfmfunds.model';

@Injectable({
  providedIn: 'root'
})
export class PfmMainService {

  pfmCategoryEmit:EventEmitter<any>;
  pfmSpendsEmit:EventEmitter<any>;
  pfmPendingbudgetEmit:EventEmitter<any>;
  pfmCompletedbudgetEmit:EventEmitter<any>;
  pfmCompletedgoalsEmit: EventEmitter<any>;
  pfmPendinggoalsEmit: EventEmitter<any>;
  pfmCancelledgoalsEmit: EventEmitter<any>;
  pfmInsightChartEmit: EventEmitter<any>;
  pfmcategoryHistoryEmit: EventEmitter<any>;
  pfmCashflowEmit:EventEmitter<any>;
  refreshActiveAndExcludeEmit:EventEmitter<any>;

  totalExpense: number = 0.00;
  pfmSpendsData:Pfmspends;
  totalFundAmount:number=0.00;
  // pfmCategoryData:pfmCategoryHistoryDisplayGrid

  currentPfmSpendDate: string;
  currentPfmFundsDate:string;
  selectedpfmCategoryData: Spendcategory;
  selectedPfmFundData:Pfmfunds;
  budgetData: Pfmbudget[];
  cashFlowThemes =
    {
      "1":'#659F23',
      "2":'#C4BE2B',
      "3":'#E0A340',
      "4":'#9F472C',
      "5":'#55306D',
      "6":'#3F94A9',
      "7":'#005469'
    };

  contextualMenuList: IContextualMenu[] = [
    {
      id: "budget",
      icon: "Budget",
      name: "Budget",
      title: "Budget",
      path: ["home", "pfm", "pfm-budget"],
      desktopPath:["home", "pfm", "pfm-budget"],
      // serviceCode: EPfmServiceCode.PFM_BUDGET,
      // processCode: EPfmServiceCode.PFM_BUDGET,
      serviceCode: "PFMBUDGET",
      processCode: "PFMBUDGET"
    },
    {
      id: "goals",
      icon: "Goals",
      name: "Goals",
      title: "Goals",
      path: ["home", "pfm", "pfm-goals-form"],
      desktopPath:["home", "pfm", "pfm-goals-form"],
      // serviceCode: ETransfersServiceCode.PFM_GOALS,
      // processCode: ETransfersServiceCode.PFM_GOALS,
      serviceCode: "PFMGOALS",
      processCode: "PFMGOALS"
    },
    {
      id: "cashflow",
      icon: "Cashflow",
      name: "Cash Flow",
      title: "Cash Flow",
      path: ["home", "pfm", "pfm-cashflow"],
      desktopPath:["home", "pfm", "pfm-cashflow"],

      // serviceCode: ETransfersServiceCode.PFM_CASHFLOW,
      // processCode: ETransfersServiceCode.PFM_CASHFLOW,
      serviceCode: 'PFMCASHFLOW',
      processCode: 'PFMCASHFLOW'
    },
    {
      id: "spendAnalyser",
      icon: "SpendAnalyser",
      name: "Spend Analyser",
      title: "Spend Analyser",
      path: ["home", "pfm"],
      desktopPath:["home", "pfm"],
      // serviceCode: EPfmServiceCode.PFM_BUDGET,
      // processCode: EPfmServiceCode.PFM_BUDGET,
      serviceCode: "PFMSPENDANALYSER",
      processCode: "PFMSPENDANALYSER"
    },
    // {
    //   id: "T004",
    //   icon: "add-payee",
    //   name: "Add Category",
    //   title: "Add Category",
    //   path: ["process-shell", "pfm", "pfm-category"],
    //   desktopPath:["home","pfm","process-shell", "pfm", "pfm-category"],

    //   // serviceCode: ETransfersServiceCode.PFM_CASHFLOW,
    //   // processCode: ETransfersServiceCode.PFM_CASHFLOW,
    //   serviceCode: 'ADDCATEGORY',
    //   processCode: 'ADDCATEGORY'
    // },
    // {
    //   id: "T005",
    //   icon: "add-payee",
    //   name: "Add Budget",
    //   title: "Add Budget",
    //   path: ["process-shell", "pfm", "add-pfm-budget-form"],
    //   desktopPath:["home","pfm","process-shell", "pfm", "add-pfm-budget-form"],

    //   // serviceCode: ETransfersServiceCode.PFM_CASHFLOW,
    //   // processCode: ETransfersServiceCode.PFM_CASHFLOW,
    //   serviceCode: 'ADDPFMBUDGET',
    //   processCode: 'ADDPFMBUDGET'
    // },
    // {
    //   id: "T005",
    //   icon: "add-payee",
    //   name: "Add Goals",
    //   title: "Add Goals",
    //   path: ["process-shell", "pfm", "pfm-add-goal"],
    //   desktopPath:["home","pfm","process-shell", "pfm", "pfm-add-goal"],

    //   // serviceCode: ETransfersServiceCode.PFM_CASHFLOW,
    //   // processCode: ETransfersServiceCode.PFM_CASHFLOW,
    //   serviceCode: 'ADDGOALS',
    //   processCode: 'ADDGOALS'
    // }

  ];

  pfm_category_svgs = {
    "others": `<svg xmlns="http://www.w3.org/2000/svg" width="22.094" height="22.094" viewBox="0 0 22.094 22.094">
    <g id="Group_17986" data-name="Group 17986" transform="translate(11460.25 5126.521)">
      <path id="Path_13064" data-name="Path 13064" d="M56.635,1136h8.256a.635.635,0,0,1,.635.635v8.256a.635.635,0,0,1-.635.635H56.635a.635.635,0,0,1-.635-.635v-8.256A.635.635,0,0,1,56.635,1136Zm.635,1.27v6.986h6.986v-6.986ZM72.83,1136a4.763,4.763,0,1,1-4.763,4.763A4.763,4.763,0,0,1,72.83,1136Zm0,1.27a3.493,3.493,0,1,0,3.493,3.493A3.493,3.493,0,0,0,72.83,1137.27Zm-12.067,10.8A4.763,4.763,0,1,1,56,1152.83,4.763,4.763,0,0,1,60.763,1148.067Zm0,1.27a3.493,3.493,0,1,0,3.493,3.493A3.493,3.493,0,0,0,60.763,1149.337Zm7.939-1.27h8.256a.635.635,0,0,1,.635.635v8.256a.635.635,0,0,1-.635.635H68.7a.635.635,0,0,1-.635-.635V1148.7A.635.635,0,0,1,68.7,1148.067Zm.635,8.256h6.986v-6.986H69.337Z" transform="translate(-11516 -6262.271)" fill="#00a10b" stroke="#00a10b" stroke-width="0.5"/>
    </g>
  </svg>
  `,
    "travel": `<svg xmlns="http://www.w3.org/2000/svg" width="32.492" height="23.483" viewBox="0 0 32.492 23.483">
    <path id="np_plane_1792134_000000" d="M28.74,1.3A6.055,6.055,0,0,0,24.089.019,4.661,4.661,0,0,0,22.33.466a43.731,43.731,0,0,0-8.615,5.605c-.179.119-.328.239-.477.328l-2.5,1.58c-.09.059-.149.09-.239.149-.715.328-3.19,1.342-5.307-.059-.03,0-.03-.03-.059-.03L3.7,7.264a.592.592,0,0,0-.627.03l-2.832,2A.565.565,0,0,0,0,9.738a.594.594,0,0,0,.208.477L6.35,15.433a.626.626,0,0,0,.388.149.265.265,0,0,0,.149-.03c.03,0,2.385-.566,5.575-1.64a17.652,17.652,0,0,1-1.133,3.727.457.457,0,0,0-.149.477.706.706,0,0,0,.268.447,1.086,1.086,0,0,0,.715.179,8.724,8.724,0,0,0,1.58-.208c2.146-.417,3.428-3.637,3.578-3.994l1.133-2.862c5.218-2.237,8.8-4.712,10.615-7.305A2.369,2.369,0,0,0,28.74,1.3ZM16.129,14.151c-.3.776-1.4,3.012-2.683,3.249a5.283,5.283,0,0,1-.8.119,49.2,49.2,0,0,0,1.758-7.1l4.264-2.713ZM28.085,3.716c-1.55,2.206-4.591,4.382-9.062,6.44l1.46-3.7a.607.607,0,0,0-.179-.686.54.54,0,0,0-.686-.03L13.566,9.56a.583.583,0,0,0-.268.388c-.208,1.013-.388,1.878-.566,2.653-2.8.954-5.1,1.55-5.873,1.758l-5.308-4.5L3.459,8.517l1.1.6c2.624,1.729,5.605.537,6.44.119a2.186,2.186,0,0,0,.358-.208l2.534-1.609c.179-.119.388-.268.6-.417a43.32,43.32,0,0,1,8.378-5.456,2.945,2.945,0,0,1,1.311-.328,5.078,5.078,0,0,1,3.757.954,1.219,1.219,0,0,1,.149,1.55Z" transform="translate(3.104 0.172) rotate(9)" fill="#00a10b" stroke="#00a10b" stroke-width="0.3"/>
  </svg>
  `,
    "entertainment": `<svg xmlns="http://www.w3.org/2000/svg" width="27.848" height="24.284" viewBox="0 0 27.848 24.284">
    <g id="Group_17981" data-name="Group 17981" transform="translate(11486.239 5124.422)">
      <path id="Path_13054" data-name="Path 13054" d="M30.914,31.042H23.286A11.73,11.73,0,1,0,15.9,33.656c.294,0,.589-.018.883-.038H30.914a.294.294,0,0,0,.294-.294V31.336A.294.294,0,0,0,30.914,31.042Zm-14.15,1.987c-.188,0-.38.024-.571.029H15.9a11.188,11.188,0,1,1,6.41-2.017c-.144.1-.294.2-.439.294s-.324.2-.489.294a11.065,11.065,0,0,1-4.617,1.4Zm13.856,0H19.673a11.727,11.727,0,0,0,2.824-1.4H30.62Z" transform="translate(-11490 -5134.195)" fill="#00a10b" stroke="#00a10b" stroke-width="0.8"/>
      <path id="Path_13055" data-name="Path 13055" d="M30.432,26.716a9.716,9.716,0,1,0-9.716,9.716h.294a9.487,9.487,0,0,0,2.079-.294A9.716,9.716,0,0,0,30.432,26.716Zm-9.716,9.127a9.127,9.127,0,1,1,9.127-9.127A9.127,9.127,0,0,1,20.716,35.843Z" transform="translate(-11494.817 -5138.996)" fill="#00a10b" stroke="#00a10b" stroke-width="0.8"/>
      <path id="Path_13056" data-name="Path 13056" d="M37.706,29.053a2.626,2.626,0,1,0-2.626-2.626,2.626,2.626,0,0,0,2.626,2.626Zm0-4.664a2.037,2.037,0,1,1-2.037,2.037A2.037,2.037,0,0,1,37.706,24.389Z" transform="translate(-11511.809 -5143.794)" fill="#00a10b" stroke="#00a10b" stroke-width="0.8"/>
      <path id="Path_13057" data-name="Path 13057" d="M37.706,58.36a2.626,2.626,0,1,0,2.626,2.626A2.626,2.626,0,0,0,37.706,58.36Zm0,4.664a2.037,2.037,0,1,1,2.037-2.037A2.037,2.037,0,0,1,37.706,63.024Z" transform="translate(-11511.809 -5168.179)" fill="#00a10b" stroke="#00a10b" stroke-width="0.8"/>
      <path id="Path_13058" data-name="Path 13058" d="M54.986,41.08a2.626,2.626,0,1,0,2.626,2.626A2.626,2.626,0,0,0,54.986,41.08Zm0,4.664a2.037,2.037,0,1,1,2.037-2.037A2.037,2.037,0,0,1,54.986,45.744Z" transform="translate(-11524 -5155.987)" fill="#00a10b" stroke="#00a10b" stroke-width="0.8"/>
      <path id="Path_13059" data-name="Path 13059" d="M20.426,41.08a2.626,2.626,0,1,0,2.626,2.626A2.626,2.626,0,0,0,20.426,41.08Zm0,4.664a2.037,2.037,0,1,1,2.037-2.037A2.037,2.037,0,0,1,20.426,45.744Z" transform="translate(-11499.615 -5155.987)" fill="#00a10b" stroke="#00a10b" stroke-width="0.8"/>
      <path id="Path_13060" data-name="Path 13060" d="M39.25,46.649a1.4,1.4,0,1,0,1.4-1.4A1.4,1.4,0,0,0,39.25,46.649Zm2.208,0a.81.81,0,1,1-.81-.81A.81.81,0,0,1,41.458,46.649Z" transform="translate(-11514.75 -5158.929)" fill="#00a10b" stroke="#00a10b" stroke-width="0.8"/>
    </g>
  </svg>
  `,
    "home-improvement": `<svg xmlns="http://www.w3.org/2000/svg" width="28.301" height="24.225" viewBox="0 0 28.301 24.225">
    <g id="Group_17982" data-name="Group 17982" transform="translate(-112.849 -3.875)">
      <g id="Group_17985" data-name="Group 17985">
        <g id="Group_17982-2" data-name="Group 17982" transform="translate(0 1.728)">
          <path id="Path_13061" data-name="Path 13061" d="M114.476,10.88a1,1,0,0,1-.952-1.76l12-6.488a3,3,0,0,1,2.845,0l12.1,6.491a1,1,0,0,1-.946,1.762l-12.1-6.491a1,1,0,0,0-.948,0Z" fill="#00a10b" stroke="#00a10b" stroke-width="0.2" fill-rule="evenodd"/>
        </g>
        <g id="Group_17983" data-name="Group 17983" transform="translate(0.582 0.829)">
          <path id="Path_13062" data-name="Path 13062" d="M115.369,14.171a1,1,0,0,1,2,0v10a1,1,0,0,0,1,1h16a1,1,0,0,0,1-1V9.671a1,1,0,0,1,2,0v14.5a3,3,0,0,1-3,3h-16a3,3,0,0,1-3-3Z" fill="#00a10b" stroke="#00a10b" stroke-width="0.2" fill-rule="evenodd"/>
        </g>
        <g id="Group_17984" data-name="Group 17984" transform="translate(-0.907 2.228)">
          <path id="Path_13063" data-name="Path 13063" d="M135.407,6a1,1,0,1,1-2,0V3a1,1,0,1,1,2,0Z" fill="#00a10b" stroke="#00a10b" stroke-width="0.2" fill-rule="evenodd"/>
        </g>
      </g>
    </g>
  </svg>
  `,
    "drugstore": `<svg xmlns="http://www.w3.org/2000/svg" width="23.827" height="22.446" viewBox="0 0 23.827 22.446">
    <g id="Group_17953" data-name="Group 17953" transform="translate(-0.476 -0.83)">
      <path id="Path_13037" data-name="Path 13037" d="M3.785,3.873V5.664H1.635a.913.913,0,0,0-.909.916V21.592A1.441,1.441,0,0,0,1.14,22.6a1.409,1.409,0,0,0,1.006.422H13.872a1.412,1.412,0,0,0,1.006-.422,1.44,1.44,0,0,0,.412-1.013V6.58a.912.912,0,0,0-.908-.916H12.742V3.873H13.3a.8.8,0,0,0,.8-.8v-1.2a.8.8,0,0,0-.8-.8H2.721a.8.8,0,0,0-.8.8v1.2a.8.8,0,0,0,.8.8H3.785ZM14.492,19.036v2.555a.643.643,0,0,1-.183.452.613.613,0,0,1-.437.185H2.146a.613.613,0,0,1-.437-.185.645.645,0,0,1-.185-.452V19.036H14.492ZM1.524,10.6v7.635H14.492V10.6H1.524Zm6.192,3.342H6.043a.4.4,0,1,0,0,.8H7.716v1.673a.4.4,0,0,0,.8,0V14.743h1.671a.4.4,0,1,0,0-.8H8.514V12.274a.4.4,0,0,0-.8,0v1.671ZM4.583,3.873h7.36v2.19a.4.4,0,0,0,.4.4h2.04l.11.118V9.805H1.524V6.58l.111-.118H4.184a.4.4,0,0,0,.4-.4V3.873Zm-1.862-.8H13.3v-1.2H2.721v1.2ZM23.276,14.233a2,2,0,0,0-2.823,0l-2.821,2.823a2,2,0,0,0,0,2.821h0a2,2,0,0,0,2.82,0l2.823-2.821a2,2,0,0,0,0-2.823Zm-3.95,2.258,1.693,1.693-1.129,1.131a1.2,1.2,0,0,1-1.693,0v0a1.2,1.2,0,0,1,0-1.693Zm2.256,1.129-1.693-1.693L21.018,14.8a1.2,1.2,0,1,1,1.693,1.693Zm1.751-8.574a2,2,0,0,0,0-2.82v0a2,2,0,0,0-2.821,0L17.688,9.047a2,2,0,0,0,0,2.82l0,0a2,2,0,0,0,2.82,0Zm-3.95-.564,1.693,1.693L19.946,11.3a1.2,1.2,0,1,1-1.693-1.693Zm2.256,1.129L19.946,7.918l1.129-1.129a1.2,1.2,0,0,1,1.693,0h0a1.2,1.2,0,0,1,0,1.693Z" transform="translate(0 0)" fill="#00a10b" stroke="#00a10b" stroke-width="0.5" fill-rule="evenodd"/>
    </g>
  </svg>
  `,
    "recurring-bills": `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="23.079" viewBox="0 0 20 23.079">
    <path id="noun-bill-3842278" d="M157.5,35h-15a2.5,2.5,0,0,0-2.5,2.5V55.958a1.667,1.667,0,0,0,2.583,1.392l3.333-2.15,3.067,2.5h0a1.667,1.667,0,0,0,2.117,0l3.067-2.5,3.292,2.15h0A1.667,1.667,0,0,0,160,55.958V37.5a2.5,2.5,0,0,0-2.5-2.5Zm.833,20.958L155.042,53.8a1.667,1.667,0,0,0-1.967.108L150,56.408l-3.075-2.5a1.667,1.667,0,0,0-1.05-.375,1.749,1.749,0,0,0-.917.267l-3.292,2.158V37.5a.833.833,0,0,1,.833-.833h15a.833.833,0,0,1,.833.833ZM156.25,40a.833.833,0,0,1-.833.833H144.583a.833.833,0,1,1,0-1.667h10.833a.833.833,0,0,1,.833.833Zm0,5a.833.833,0,0,1-.833.833H144.583a.833.833,0,1,1,0-1.667h10.833a.833.833,0,0,1,.833.833Zm0,3.333a.833.833,0,0,1-.833.833H144.583a.833.833,0,1,1,0-1.667h10.833a.833.833,0,0,1,.833.833Zm0,3.333a.833.833,0,0,1-.833.833H144.583a.833.833,0,1,1,0-1.667h10.833a.833.833,0,0,1,.833.833Z" transform="translate(-140 -35)" fill="#00a10b"/>
  </svg>
  `,
    "hotel-motel": `<svg xmlns="http://www.w3.org/2000/svg" width="22.012" height="22.012" viewBox="0 0 22.012 22.012">
    <g id="Group_17951" data-name="Group 17951" transform="translate(12160.706 6133.333)">
      <path id="Path_13031" data-name="Path 13031" d="M46.361,11.085a1.045,1.045,0,0,0,.436-.821.265.265,0,0,0-.53,0c0,.185-.084.269-.26.426a.99.99,0,0,0,0,1.641c.175.157.259.24.259.425s-.084.268-.259.425a1.042,1.042,0,0,0-.436.82.265.265,0,1,0,.53,0c0-.184.084-.268.259-.424a.989.989,0,0,0,0-1.64c-.175-.157-.26-.241-.26-.426S46.186,11.242,46.361,11.085Z" transform="translate(-12196.497 -6142.932)" fill="#00a10b" stroke="#00a10b" stroke-width="0.8"/>
      <path id="Path_13032" data-name="Path 13032" d="M53.538,11.085a1.045,1.045,0,0,0,.436-.821.265.265,0,0,0-.53,0c0,.185-.084.269-.26.426a.991.991,0,0,0,0,1.641c.175.157.259.24.259.425s-.084.268-.259.425a1.043,1.043,0,0,0-.436.82.265.265,0,0,0,.53,0c0-.184.084-.268.259-.424a.99.99,0,0,0,0-1.64c-.175-.157-.26-.241-.26-.426S53.362,11.242,53.538,11.085Z" transform="translate(-12201.771 -6142.932)" fill="#00a10b" stroke="#00a10b" stroke-width="0.8"/>
      <path id="Path_13033" data-name="Path 13033" d="M62.092,54.192a7.081,7.081,0,0,0-5.536-5.08.265.265,0,1,0-.095.522,6.549,6.549,0,0,1,5.119,4.7.265.265,0,1,0,.511-.139Z" transform="translate(-12204.34 -6171.67)" fill="#00a10b" stroke="#00a10b" stroke-width="0.8"/>
      <path id="Path_13034" data-name="Path 13034" d="M31.14,43.682h-.4v-.6a9.957,9.957,0,0,0-9.406-9.93,1.37,1.37,0,1,0-1.077,0,9.957,9.957,0,0,0-9.406,9.93v.6h-.4a.265.265,0,0,0-.265.265v2.08a.265.265,0,0,0,.265.265H31.14a.265.265,0,0,0,.265-.265v-2.08A.266.266,0,0,0,31.14,43.682ZM19.959,31.893a.84.84,0,1,1,.84.84A.841.841,0,0,1,19.959,31.893ZM11.385,43.082a9.414,9.414,0,1,1,18.829,0v.6H11.385Zm19.49,2.68H10.724v-1.55H30.875Z" transform="translate(-12170.5 -6158.013)" fill="#00a10b" stroke="#00a10b" stroke-width="0.8"/>
    </g>
  </svg>
  `,
    "restaurants": `<svg xmlns="http://www.w3.org/2000/svg" width="22.59" height="28.2" viewBox="0 0 22.59 28.2">
    <path id="np_food_2642440_000000" d="M22.743,3.1a.927.927,0,0,0-.64.282L20.237,5.253a.938.938,0,0,0-.276.661V8.768A8.41,8.41,0,0,0,12.5,17.022a1.112,1.112,0,0,0,.031.344l3.732,13.061a.931.931,0,0,0,.9.676H33.955a.934.934,0,0,0,.934-.933V23.64a3.744,3.744,0,0,0-3.732-3.732H28.531l.727-2.542a1.353,1.353,0,0,0,.029-.371,8.41,8.41,0,0,0-7.458-8.226V6.3L23.424,4.71A.933.933,0,0,0,22.745,3.1Zm-2.783,7.548v5.526h-5.5A6.5,6.5,0,0,1,19.961,10.652Zm1.867,0a6.5,6.5,0,0,1,5.5,5.526h-5.5Zm-7.158,7.39H27.122l-.533,1.866H25.561a3.744,3.744,0,0,0-3.732,3.732v5.6H17.867Zm10.891,3.732h5.6a1.842,1.842,0,0,1,1.866,1.866V25.5h-9.33V23.641a1.842,1.842,0,0,1,1.866-1.866Zm-1.867,5.6h9.328v1.865H23.694Z" transform="translate(-12.401 -3.003)" fill="#00a10b" stroke="#fff" stroke-width="0.2"/>
  </svg>
  `,
    "gas": `<svg xmlns="http://www.w3.org/2000/svg" width="24.531" height="23.797" viewBox="0 0 24.531 23.797">
    <g id="Group_17952" data-name="Group 17952" transform="translate(-73.05 -44.95)">
      <path id="Path_13035" data-name="Path 13035" d="M199.177,113.6H189.1a.594.594,0,0,0-.6.6v5.773a.594.594,0,0,0,.6.6h10.081a.594.594,0,0,0,.6-.6V114.2A.594.594,0,0,0,199.177,113.6Zm-.6,5.773h-8.888v-4.58h8.888Z" transform="translate(-107.658 -63.96)" fill="#00a10b" stroke="#00a10b" stroke-width="0.3"/>
      <path id="Path_13036" data-name="Path 13036" d="M96.828,67.4H94.806V48.367A3.27,3.27,0,0,0,91.539,45.1H81.418a3.27,3.27,0,0,0-3.267,3.267V64.4h-.272a2.161,2.161,0,0,1-2.161-2.161v-3.1h.729a.594.594,0,0,0,.6-.6V52.689a.594.594,0,0,0-.6-.6h-.729V50.541a.494.494,0,0,1,.5-.484h.232a.6.6,0,1,0,0-1.193h-.232a1.69,1.69,0,0,0-1.69,1.677v1.551H73.8a.594.594,0,0,0-.6.6v5.859a.594.594,0,0,0,.6.6h.729v3.1a3.358,3.358,0,0,0,3.354,3.354h.272V67.4H76.129a.6.6,0,0,0,0,1.193H96.834a.6.6,0,1,0-.007-1.193ZM74.4,53.285h1.458v4.666H74.4ZM79.344,67.4V48.367a2.073,2.073,0,0,1,2.074-2.074H91.546a2.073,2.073,0,0,1,2.074,2.074V67.4Z" transform="translate(0 0)" fill="#00a10b" stroke="#00a10b" stroke-width="0.3"/>
    </g>
  </svg>
  `,
    "groceries": `<svg xmlns="http://www.w3.org/2000/svg" width="26.021" height="27.142" viewBox="0 0 26.021 27.142">
    <path id="Path_13030" data-name="Path 13030" d="M46.517,25.472h-1.33a6.077,6.077,0,0,0-5.647-5.629l0-.77a4.985,4.985,0,0,0,3.341-1.293,5.314,5.314,0,0,0,1.1-3.82.426.426,0,0,0-.4-.38,5.31,5.31,0,0,0-3.757,1.293,3.642,3.642,0,0,0-.711,1.119,3.693,3.693,0,0,0-.73-1.129A5.356,5.356,0,0,0,34.6,13.58a.426.426,0,0,0-.4.385,5.356,5.356,0,0,0,1.142,3.827,5.018,5.018,0,0,0,3.348,1.281l0,.77a6.077,6.077,0,0,0-5.611,5.628H30.407l.047-.734a2.025,2.025,0,0,0-2-2.278h-.739V21.088a2.7,2.7,0,0,0,3.664-2.494,2.655,2.655,0,0,0-.589-1.661,2.651,2.651,0,0,0-1.065-4.122,2.371,2.371,0,0,0,.03-.372,2.467,2.467,0,0,0-4.933,0,2.421,2.421,0,0,0,.029.372,2.651,2.651,0,0,0-1.065,4.122,2.655,2.655,0,0,0-.589,1.661,2.7,2.7,0,0,0,3.664,2.494V22.46h-.739a2.024,2.024,0,0,0-2.006,2.251l.045.761H21.85a.426.426,0,0,0-.427.427V36.215a.426.426,0,0,0,.427.427H46.517a.426.426,0,0,0,.427-.427V25.9A.426.426,0,0,0,46.517,25.472ZM40.441,15.46a4.142,4.142,0,0,1,2.706-1.024,4.141,4.141,0,0,1-.881,2.756,4.143,4.143,0,0,1-2.706,1.024A4.142,4.142,0,0,1,40.441,15.46ZM35.956,17.2a4.188,4.188,0,0,1-.918-2.764,4.184,4.184,0,0,1,2.729,1.019,4.188,4.188,0,0,1,.918,2.764A4.184,4.184,0,0,1,35.956,17.2Zm3.176,3.475a5.228,5.228,0,0,1,5.2,4.8H42.564a3.255,3.255,0,0,0-3.221-2.825.427.427,0,1,0,0,.853A2.4,2.4,0,0,1,41.7,25.472H33.929A5.227,5.227,0,0,1,39.131,20.675ZM25.9,20.413a1.838,1.838,0,0,1-1.852-1.82,1.785,1.785,0,0,1,.606-1.343.427.427,0,0,0,0-.636,1.785,1.785,0,0,1-.606-1.343,1.819,1.819,0,0,1,1.41-1.765.427.427,0,0,0,.3-.555,1.553,1.553,0,0,1-.088-.513,1.613,1.613,0,0,1,3.226,0,1.56,1.56,0,0,1-.089.513.427.427,0,0,0,.3.555,1.819,1.819,0,0,1,1.41,1.765,1.785,1.785,0,0,1-.606,1.343.427.427,0,0,0,0,.636,1.785,1.785,0,0,1,.606,1.343,1.847,1.847,0,0,1-2.81,1.549V14.594a.427.427,0,1,0-.853,0v5.548A1.849,1.849,0,0,1,25.9,20.413Zm-.65,3.293a1.147,1.147,0,0,1,.87-.393H28.45a1.146,1.146,0,0,1,.87.393,1.2,1.2,0,0,1,.284.951l-.052.814h-4.54l-.05-.838A1.182,1.182,0,0,1,25.249,23.706ZM46.09,35.788H22.276V26.325H46.09Z" transform="translate(-21.173 -9.75)" fill="#00a10b" stroke="#00a10b" stroke-width="0.5"/>
  </svg>
  `,
    "furniture": `<svg xmlns="http://www.w3.org/2000/svg" width="24.2" height="20.335" viewBox="0 0 24.2 20.335">
    <g id="Group_14124" data-name="Group 14124" transform="translate(-131.781 -914.704)">
      <path id="np_tv_3264494_000000" d="M.743,8.051A.75.75,0,0,0,0,8.8V24.227a.75.75,0,0,0,.747.753H9.558v1.705H7.443a.751.751,0,0,0,.072,1.5h8.956a.75.75,0,1,0,0-1.5H14.429V24.98h8.813A.751.751,0,0,0,24,24.227V8.8a.751.751,0,0,0-.755-.753Zm.755,1.5h21V23.479H1.5Zm2.247,1.5A.75.75,0,0,0,3,11.8v9.429a.75.75,0,0,0,.747.747h16.5a.75.75,0,0,0,.753-.747V11.8a.749.749,0,0,0-.753-.753Zm.747,1.5h15v7.927h-15Zm6.567,12.428h1.87v1.705H11.058Z" transform="translate(131.885 906.754)" fill="#00a10b" stroke="#00a10b" stroke-width="0.2"/>
    </g>
    </svg>`
  };



  constructor(public accountsService: AccountsService,
    public commonService: CommonService,
    private _httpProvider:HttpProviderService) {
  }

  getMenuList(): IContextualMenu[] {
    return this.contextualMenuList;
  }

  getBeneInitial(beneName: string) {
    if (beneName && beneName != '') {
      let initial: string = beneName.charAt(0);
      if (beneName.split(' ').length > 1) {
        initial = initial + beneName.split(' ')[1].charAt(0);
      }
      return initial;
    }
    return
  }


  getAccountList(){
    return this.accountsService.getList();
  }


  getAccountListById(accNum){
    return this.accountsService.getAccountDetailsData(accNum);
  }


  apiAmountformat(tranAmount: any) {
    if(!tranAmount || tranAmount!=null || tranAmount!='' ){
      return  parseFloat(tranAmount)
    }else{
      return 0.00
    }
  }

  getminAndMaxDate(duration?,yearOrMonth?){
    if(yearOrMonth){
      return moment(new Date()).add(duration,yearOrMonth).format(API_DATE_FORMAT);
    }else{
      return moment(new Date()).format(API_DATE_FORMAT);
    }

  }
  percentCalculate(tranTotal){
    const totalExpense= this.totalExpense;
    const percent=(parseInt(tranTotal)/totalExpense)*100;
    return percent?.toFixed(2);
  }


  sortArrayByString(arr,sortByName) {
    if(arr){
      return arr?.sort( function( a, b ) {
          a = a[sortByName]?.toLowerCase();
          b = b[sortByName]?.toLowerCase();
          return a < b ? -1 : a > b ? 1 : 0;
      });
    }else{
      return undefined;
    }
  }



  sortArrayByNumber(arr,sortByName) {
    if(arr){
      return arr?.sort( function( a, b ) {
          a = parseFloat(a[sortByName]);
          b = parseFloat(b[sortByName]);
          return a > b ? -1 : a < b ? 1 : 0;
      });
    }else{
      return undefined;
    }
  }


  



}
